// extracted by mini-css-extract-plugin
var _1 = "gGlB9P6_LiqDTdMc8uNP";
var _2 = "gGlB9P6_LiqDTdMc8uNP";
export { _1 as "primary-button", _2 as "primaryButton" }
